module.exports = __webpack_public_path__ + "img/clock.6b7becb1.svg";